<template>
    <div id="viewFile"></div>
</template>
<script>
    import {simpleModeKey} from "@/constant";

    export default {
        props:['wpsUrl','token'],
        data(){
            return{
                // 是否开启简易模式
                simpleMode: 'normal'
            }
        },
        created() {
            this.simpleMode = localStorage.getItem(simpleModeKey)
        },
        mounted(){
            this.openWps(this.wpsUrl,this.token);
        },
        methods:{
            openWps(url, token) {
                let _this = this;
                const wps = _this.wps.config({
                    mode: _this.simpleMode,
                    mount: document.querySelector('#app'),
                    wpsUrl: url,
                });
                wps.setToken({token});
                let app = wps.Application;
                this.console.log(JSON.stringify(app))
            }
        }
    }
</script>
